/* src/app/external-registration/external-registration.component.css */
body {
  background-color: #f2f2f2;
}
.reg_wrapper {
  margin: 55px 0px 55px 0px;
}
.reg_left {
  text-align: left;
  color: #fff;
}
.reg_left p {
  font-size: 18px;
  margin-top: 20px;
}
.reg_left span {
  font-size: 12px;
}
.reg_right {
  text-align: left;
}
.reg_right strong {
  color: #ffffff;
}
.reg_submit {
  padding: 0px;
}
.reg_submit {
  background-color: #fff !important;
  color: #000;
  border-radius: 30px;
  margin-top: 16px;
  text-transform: capitalize;
  box-shadow: none !important;
  float: left;
  padding: 6px 15px;
  height: auto;
  line-height: normal;
}
.reg_reset {
  padding: 23px 10px 0px 10px;
  color: #fff;
  float: left;
  font-size: 12px;
  cursor: pointer;
}
.reg_reset a {
  color: #ffffff;
}
.createnew-sel {
  display: block;
  border: none;
  border-radius: 0px;
  border-bottom: solid 1px #fff;
  font-size: 11px;
  padding-top: 15px;
  color: #8bd0f3;
  width: 100%;
  outline: none !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent url(/assets/images/down_arrow.png) no-repeat right 20px;
}
.input-field label {
  font-size: 11px;
  padding-left: 5px;
  color: #8bd0f3 !important;
  font-weight: normal;
}
.input-field input {
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #fff;
  height: 44px;
  background: transparent;
  border: none;
  border-bottom: 1px solid #fff;
}
.submit_main {
  padding: 0px;
}
.reg_bg {
  background: #ffffff url(/assets/images/ots_bg.png) no-repeat center top;
  height: auto;
  text-align: center;
  padding-top: 36px;
  padding-bottom: 20px;
  background-size: cover;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  border-bottom-color: #fff !important;
  color: #ea1d25;
  margin-top: 0px;
  position: relative;
  background-color: #00cee7;
  padding: 6px;
}
.eye_modify {
  cursor: pointer;
  pointer-events: all;
  color: #ffffff;
  font-size: 18px;
  margin-top: -5px;
}
.phoneField {
  float: left;
  width: 45%;
}
.phoneField-right {
  margin-left: 10%;
}
.input-ErrorField {
  color: #cc0000 !important;
}
input.ng-touched.ng-invalid,
.phoneField .ng-touched.ng-invalid input {
  border-bottom-color: #e13131 !important;
}
input[type=text],
input[type=password],
.ui-dropdown {
  box-sizing: border-box !important;
}
input[type=text],
input[type=password],
.ui-dropdown {
  width: 100% !important;
}
.addMandatory {
  position: relative;
}
.addMandatory::before {
  content: "*";
  font-size: 20px;
  color: #cc0000;
  position: absolute;
  left: -11px;
}
.addMandatory.posAlter {
  clear: both;
}
.addMandatory.posAlter::before {
  top: 16px;
}
.passwordCondition {
  text-align: left;
  font-size: 13px !important;
  color: black;
  font-family: helvetica;
  background: rgba(255, 255, 255, 0.5);
  padding: 20px;
  padding-top: 0;
  margin-top: 40px !important;
}
.leftField {
  width: 45%;
  margin-right: 8%;
  clear: both;
  display: inline-block;
}
.rightField {
  width: 45%;
  display: inline-block;
}
@media screen and (min-width: 300px) and (max-width: 480px) {
  .phoneField {
    width: 100%;
  }
  .phoneField-right {
    margin-left: 0;
  }
  .leftField,
  .rightField {
    width: 100%;
    margin-right: 0;
  }
}
@media screen and (min-width: 300px) and (max-width: 700px) {
  .reg_bg {
    padding-top: 10px;
    background-size: cover;
  }
  .reg_wrapper {
    margin: 0px;
  }
}
.addMandatory.posAlterCountry::before {
  top: -14px;
}
::ng-deep .p-autocomplete input::placeholder {
  color: grey !important;
}
/*# sourceMappingURL=external-registration.component.css.map */
